import { Row, Card } from "react-bootstrap";

import { education } from "../Data";

import { FaExternalLinkAlt } from "react-icons/fa";

const Education = () => {
    return (
        <>
            {education.map((ed) => (
                <Row key={ed.grade} className="mb-3">
                    <Card>
                        <Card.Header className="text-center">
                            <small>
                                <b>
                                    {ed.from}-{ed.to}
                                </b>
                            </small>
                        </Card.Header>
                        <Card.Body>
                            <div className="d-flex justify-content-between">
                                <a
                                    href={ed.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <b>
                                        {ed.institute} <FaExternalLinkAlt />
                                    </b>
                                </a>
                                <b>{ed.grade}</b>
                            </div>
                            <Card.Subtitle className="text-muted">
                                {ed.course}
                            </Card.Subtitle>
                            <Card.Text>
                                <i>
                                    <small>
                                        {ed.specialisation}
                                        &nbsp;
                                        {
                                            ed.link &&
                                            <a
                                                href={`/assets/${ed.link}.pdf`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <b>{ed.achievement} <FaExternalLinkAlt /></b>
                                            </a>
                                        }
                                    </small>
                                </i>
                                <br />
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Row>
            ))}
        </>
    );
};

export default Education;
